module.exports = __webpack_public_path__ + "img/chm.b7e32f2a.svg";